import { defineApiActionTypes } from 'store/common/action-helpers';
const prefix = 'features/professions';

export const SET_USER_PROFESSIONS = defineApiActionTypes(`${prefix}/SET_USER_PROFESSIONS`);



// WEBPACK FOOTER //
// ./src/store/features/professions/action-types.js